import { toast } from 'sonner';

// Drop-in replacement for window.alert(): picks success/error tone from the text.
const ERROR_HINT = /(fail|error|could ?n[o']?t|cannot|can't|invalid|not allowed|denied|unable|required|must|exceed|missing|only |please|not found|forbidden|blocked|too many|expired)/i;

const toText = (msg) => {
  if (msg == null) return '';
  if (typeof msg === 'string') return msg;
  if (Array.isArray(msg)) return msg.map((m) => m?.msg || toText(m)).join(', ');
  return msg.message || msg.detail || msg.msg || JSON.stringify(msg);
};

export const notify = (msg, tone) => {
  const text = toText(msg);
  const kind = tone || (ERROR_HINT.test(text) ? 'error' : 'success');
  (toast[kind] || toast)(text, { duration: kind === 'error' ? 6000 : 3500 });
};

export const notifyError = (msg) => notify(msg, 'error');
export const notifySuccess = (msg) => notify(msg, 'success');
